import React from 'react'
import Login from '../Login/login'
import Register from '../Login/register'
import ForgotPass from '../Login/forgotpassword'

export default class Header extends React.Component {

    constructor() {
        super()
        this.state = {
            ShowModal: false,
            ShowModalreg: false,
            ShowModalforgot: false
        }
    }

    cancelHandler = () => {
        this.setState({
            ShowModal: false
        })
    }

    cancelRegHandler = () => {
        this.setState({
            ShowModalreg: false
        })
    }

    cancelforgotHandler = () => {
        this.setState({
            ShowModalforgot: false
        })
    }

    ModalHandler = () => {
        this.setState({
            ShowModal: true,
            ShowModalreg: false,
            ShowModalforgot:false
        })
    }

    ModalRegHandler = () => {
        this.setState({
            ShowModalreg: true,
            ShowModal:false,
            ShowModalforgot:false
        })
    }

    ModalLupassHandler = () => {
        this.setState({
            ShowModalforgot:true,
            ShowModalreg: false,
            ShowModal:false

        })
    }
    


    render() {
        const {ShowModal, ShowModalreg,ShowModalforgot} = this.state
        return (
            <div>
                <div class="header">
                    <div class="header-left">
                        <a href="/" class="logo">
                            <img src="assets/img/logo.png" width="35" height="35" alt="" /> <span>Med.id</span>
                        </a>
                    </div>


                    <div class="row">
                        <div class="header-middle col">
                            <div class="input-group">
                                <input class="form-control rounded-left" type="text" placeholder="Cari Dokter atau Faskes" />
                                <div class="input-group-append">
                                    <button class="btn btn-primary" type="button">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="header-right col-3 mt-2">
                            <button type="button" class="btn btn-primary mr-2" onClick={this.ModalRegHandler}>Daftar</button>
                            <button type="button" class="btn btn-light" onClick={this.ModalHandler}>Masuk</button>
                        </div>

                    </div>
                </div>
            <Login ShowModal={ShowModal}
            cancelHandler={this.cancelHandler}
            ModalRegHandler={this.ModalRegHandler}
            ModalLupassHandler={this.ModalLupassHandler}
            />
            <Register ShowModalreg={ShowModalreg}
            cancelRegHandler={this.cancelRegHandler}
            ModalHandler={this.ModalHandler}
            />
            <ForgotPass ShowModalforgot={ShowModalforgot}
            cancelforgotHandler={this.cancelforgotHandler}
            ModalHandler={this.ModalHandler}
            />
            </div>

        )
    }
}